import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { OrganizationFileBreadcrumb } from "@forgepoint/shared";

interface VaultBreadcrumbsProps {
  breadcrumbs: OrganizationFileBreadcrumb[];
  onNavigate: (folderId: string | null) => void;
}

/**
 * Breadcrumb trail for vault navigation. The leading "Vault" crumb navigates
 * to the root (null); each folder crumb navigates to that folder.
 */
export function VaultBreadcrumbs({
  breadcrumbs,
  onNavigate,
}: VaultBreadcrumbsProps) {
  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        className="h-7 px-2"
        onClick={() => onNavigate(null)}
      >
        Vault
      </Button>
      {breadcrumbs.map((breadcrumb) => (
        <div key={breadcrumb.id} className="flex items-center gap-1 min-w-0">
          <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />
          <Button
            variant="ghost"
            size="sm"
            className="h-7 px-2 max-w-[220px] truncate"
            onClick={() => onNavigate(breadcrumb.id)}
          >
            {breadcrumb.name}
          </Button>
        </div>
      ))}
    </>
  );
}
